import * as React from "react";
import { isUndefinedOrNull } from "../utils/assertions";

export function useControlledState<T>(
  value?: T,
  defaultValue?: T,
  onChange?: (value: T) => void
) {
  const [state, setState] = React.useState(value || defaultValue);
  const isControlled = !isUndefinedOrNull(value);

  const controlledValue = isControlled ? value : state;

  const setValue = React.useCallback(
    (value: T) => {
      if (!isControlled) {
        setState(value);
      }

      if (!Object.is(controlledValue, value)) {
        onChange?.(value);
      }
    },
    [isControlled, controlledValue]
  );

  return [controlledValue, setValue] as [T, (value: T) => void];
}
